import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AuthStoreService } from '../core/auth-store.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.html',
  styleUrls: ['./nav.scss'],
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavComponent {
  private router = inject(Router);
  private authStore = inject(AuthStoreService);
  showNav = signal(true);
  currentUser = this.authStore.currentUser;

  readonly links = [
    { label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
    { label: 'Organizations', path: '/organizations', icon: 'apartment' },
    { label: 'Accounts', path: '/accounts', icon: 'business' },
    { label: 'Users', path: '/users', icon: 'group' },
    { label: 'Queues', path: '/queues', icon: 'queue' },
    { label: 'KYC', path: '/kyc', icon: 'fact_check' },
    { label: 'Audit Logs', path: '/audit-logs', icon: 'history' },
  ];

  constructor() {
    // initialize based on current url
    this.updateShowNav(this.router.url);

    // update on navigation
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.updateShowNav(e.urlAfterRedirects);
      }
    });
  }

  private updateShowNav(url: string) {
    // hide nav on the login route (root path)
    const hide = url === '/' || url === '' || url.startsWith('/login');
    this.showNav.set(!hide);
  }

  logout() {
    this.authStore.clearSession();
    this.router.navigate(['/']);
  }
}
